import { useEffect } from "react";
import { kickoutUser } from "../lib/network";
import { useParams } from "react-router-dom";

/**
 * A hook for handling session errors from legacy iframes
 * @example
 * ```tsx
 * export const MyComponent = () => {
    useIframeSessionListener();
  
    return (
      <>
        <iframe
          title='exchange'
          style={{ border: "2px solid black" }}
          src={`https://someurl/foo/bar.php`}
          onLoad={() => console.log("iframe loaded")}
          onError={() => console.log("iframe failed to load")}
          width="100%"
          height="100%"
        />
      </>
    );
  };
 * ```
 */
export const useIframeSessionListener = () => {
  const params = useParams<{ site: string }>();
  const site = params.site;
  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.data.type === "kickout") kickoutUser(site);
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
};
